// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5.5 2L2.75 4.75L5.5 7.5M2.75 4.75H13.25',
  'M10.5 8.5L13.25 11.25L10.5 14M13.25 11.25H2.75',
];
